export function getRandomInquiryAnalyticsData(topicOptions) {
  // Helper functions
  function getRandomElement(array) {
    return array[Math.floor(Math.random() * array.length)];
  }

  function getRandomDate(start, end) {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
  }

  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  // Test planners
  const testPlanners = [
    { id: 'test-planner-1', first_name: 'Sarah', last_name: 'Johnson', email: 'sarah.johnson@example.com' },
    { id: 'test-planner-2', first_name: 'Michael', last_name: 'Chen', email: 'michael.chen@example.com' },
    { id: 'test-planner-3', first_name: 'Emily', last_name: 'Davis', email: 'emily.davis@example.com' },
    { id: 'test-planner-4', first_name: 'David', last_name: 'Rodriguez', email: 'david.rodriguez@example.com' },
    { id: 'test-planner-5', first_name: 'Lisa', last_name: 'Thompson', email: 'lisa.thompson@example.com' }
  ];

  // Data for generating realistic content
  const firstNames = [
    'Emma', 'Liam', 'Olivia', 'Noah', 'Ava', 'William', 'Sophia', 'Mason', 'Isabella', 'James',
    'Charlotte', 'Benjamin', 'Amelia', 'Lucas', 'Mia', 'Henry', 'Harper', 'Alexander', 'Evelyn', 'Michael',
    'Abigail', 'Ethan', 'Emily', 'Daniel', 'Elizabeth', 'Matthew', 'Sofia', 'Aiden', 'Avery', 'Jackson',
    'Ella', 'Samuel', 'Madison', 'Sebastian', 'Scarlett', 'David', 'Victoria', 'Carter', 'Aria', 'Joseph'
  ];

  const lastNames = [
    'Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis', 'Rodriguez', 'Martinez',
    'Hernandez', 'Lopez', 'Gonzalez', 'Wilson', 'Anderson', 'Thomas', 'Taylor', 'Moore', 'Jackson', 'Martin',
    'Lee', 'Perez', 'Thompson', 'White', 'Harris', 'Sanchez', 'Clark', 'Ramirez', 'Lewis', 'Robinson',
    'Walker', 'Young', 'Allen', 'King', 'Wright', 'Scott', 'Torres', 'Nguyen', 'Hill', 'Flores'
  ];

  const streetNames = [
    'Main St', 'Oak Ave', 'Maple Dr', 'Pine Rd', 'Cedar Ln', 'Elm St', 'First Ave', 'Second St', 'Park Ave', 'Church St',
    'Washington St', 'Lincoln Ave', 'Jefferson Dr', 'Madison Rd', 'Franklin Ln', 'Roosevelt Ave', 'Wilson St', 'Highland Ave',
    'Sunset Blvd', 'River Rd', 'Hill St', 'Valley Dr', 'Mountain View Ave', 'Forest Ln', 'Lake Dr', 'Garden St',
    'Spring St', 'Summer Ave', 'Winter Rd', 'Autumn Ln', 'Sunny Dr', 'Green St', 'Blue Ave', 'Rose Dr'
  ];

  const statuses = ['not-started', 'in-progress', 'complete'];
  const submissionMethods = ['email', 'phone', 'in-person', 'assessment', 'form'];
  const priorities = ['normal', 'high'];
  const emailStatuses = ['unread', 'response_needed', 'response_sent'];

  const inquirySubjects = [
    'Question about shed construction',
    'Deck building requirements',
    'ADU feasibility inquiry',
    'Setback regulations question',
    'Height restriction clarification',
    'Parking requirement inquiry',
    'Fence installation rules',
    'Home addition approval',
    'Pool installation guidelines',
    'Business license requirements',
    'Zoning variance question',
    'Building permit inquiry',
    'Property line clarification',
    'Development regulations',
    'Construction code question'
  ];

  // Generate random inquiries
  const inquiries = [];
  const endDate = new Date();
  const startDate = new Date();
  startDate.setFullYear(endDate.getFullYear() - 2); // 2 years of data

  // Generate between 400-450 inquiries
  const numInquiries = 400 + Math.floor(Math.random() * 51);

  for (let i = 0; i < numInquiries; i++) {
    const dateSubmitted = getRandomDate(startDate, endDate);
    const status = getRandomElement(statuses);
    const submissionMethod = getRandomElement(submissionMethods);
    const topic = getRandomElement(topicOptions);

    // Determine date_last_updated based on status
    let dateLastUpdated;
    if (status === 'not-started') {
      dateLastUpdated = dateSubmitted;
    } else {
      // Add random days between submission and last update
      const daysToAdd = Math.floor(Math.random() * 30) + 1;
      dateLastUpdated = addDays(dateSubmitted, daysToAdd);
      if (dateLastUpdated > endDate) dateLastUpdated = endDate;
    }

    // Determine assignees (70% chance of having assignees)
    let assignees = [];
    if (Math.random() < 0.7) {
      const numAssignees = Math.random() < 0.8 ? 1 : 2; // 80% single assignee, 20% two assignees
      const selectedPlanners = [];
      for (let j = 0; j < numAssignees; j++) {
        let planner;
        do {
          planner = getRandomElement(testPlanners).id;
        } while (selectedPlanners.includes(planner));
        selectedPlanners.push(planner);
      }
      assignees = selectedPlanners;
    }

    // Generate email status based on status
    let emailStatus;
    if (status === 'complete') {
      emailStatus = 'response_sent';
    } else {
      emailStatus = getRandomElement(emailStatuses);
    }

    const firstName = getRandomElement(firstNames);
    const lastName = getRandomElement(lastNames);
    const streetNumber = Math.floor(Math.random() * 9999) + 1;
    const streetName = getRandomElement(streetNames);

    const inquiry = {
      id: `test-inquiry-${i + 1}`,
      subject: getRandomElement(inquirySubjects),
      submitterFirstName: firstName,
      submitterLastName: lastName,
      submitterEmail: `${firstName.toLowerCase()}.${lastName.toLowerCase()}@email.com`,
      topic: topic,
      status: status,
      assignees: assignees,
      submissionMethod: submissionMethod,
      priority: getRandomElement(priorities),
      dateSubmitted: dateSubmitted.toISOString(),
      dateLastUpdated: dateLastUpdated.toISOString(),
      dateMarkedAsComplete: status === 'complete' ? dateLastUpdated.toISOString() : null,
      address: `${streetNumber} ${streetName}`,
      read: Math.random() < 0.8, // 80% read
      fileUrls: Math.random() < 0.3 ? [`https://example.com/file${i}.pdf`] : [], // 30% have files
      emailStatus: emailStatus,
      isDemo: true
    };

    inquiries.push(inquiry);
  }

  return {
    inquiries,
    profiles: testPlanners,
    topicOptions
  };
} 